/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/__root'
import { Route as OwnerRouteImport } from './app/$owner'
import { Route as IndexRouteImport } from './app/index'
import { Route as OwnerIndexRouteImport } from './app/$owner/index'
import { Route as SlackClaimRouteImport } from './app/slack/claim'
import { Route as OrgsNewRouteImport } from './app/orgs/new'
import { Route as OauthDeviceRouteImport } from './app/oauth/device'
import { Route as OauthConsentRouteImport } from './app/oauth/consent'
import { Route as AuthResetPasswordRouteImport } from './app/auth/reset-password'
import { Route as AuthLogoutRouteImport } from './app/auth/logout'
import { Route as AuthLoginRouteImport } from './app/auth/login'
import { Route as AuthCallbackRouteImport } from './app/auth/callback'
import { Route as AuthAcceptInvitationRouteImport } from './app/auth/accept-invitation'
import { Route as AccountSettingsRouteImport } from './app/account/settings'
import { Route as OwnerConnectorsRouteImport } from './app/$owner/connectors'
import { Route as OwnerAutomationsRouteImport } from './app/$owner/automations'
import { Route as OwnerAgentsRouteImport } from './app/$owner/agents'
import { Route as OwnerSplatRouteImport } from './app/$owner/$'
import { Route as OwnerSettingsIndexRouteImport } from './app/$owner/settings/index'
import { Route as OwnerMemoryIndexRouteImport } from './app/$owner/memory/index'
import { Route as OwnerMembersIndexRouteImport } from './app/$owner/members/index'
import { Route as OwnerEventsIndexRouteImport } from './app/$owner/events/index'
import { Route as OwnerDataIndexRouteImport } from './app/$owner/data/index'
import { Route as OwnerConnectorsIndexRouteImport } from './app/$owner/connectors/index'
import { Route as OwnerChatIndexRouteImport } from './app/$owner/chat/index'
import { Route as OwnerAutomationsIndexRouteImport } from './app/$owner/automations/index'
import { Route as OwnerAgentsIndexRouteImport } from './app/$owner/agents/index'
import { Route as OwnerEntityTypeIndexRouteImport } from './app/$owner/$entityType/index'
import { Route as ConnectorNameConnectionRouteImport } from './app/connector/$name/connection'
import { Route as OwnerViewsViewRouteImport } from './app/$owner/views/$view'
import { Route as OwnerSettingsOrganizationRouteImport } from './app/$owner/settings/organization'
import { Route as OwnerMemorySplatRouteImport } from './app/$owner/memory/$'
import { Route as OwnerEventsEventIdRouteImport } from './app/$owner/events/$eventId'
import { Route as OwnerEventsSplatRouteImport } from './app/$owner/events/$'
import { Route as OwnerEntityTypesNewRouteImport } from './app/$owner/entity-types/new'
import { Route as OwnerEntityTypesSlugRouteImport } from './app/$owner/entity-types/$slug'
import { Route as OwnerConnectorsCreateRouteImport } from './app/$owner/connectors/create'
import { Route as OwnerChatAgentIdRouteImport } from './app/$owner/chat/$agentId'
import { Route as OwnerAutomationsNewRouteImport } from './app/$owner/automations/new'
import { Route as OwnerAutomationsAutomationIdRouteImport } from './app/$owner/automations/$automationId'
import { Route as OwnerAgentsNewRouteImport } from './app/$owner/agents/new'
import { Route as OwnerAgentsConnectRouteImport } from './app/$owner/agents/connect'
import { Route as OwnerAgentsAgentIdRouteImport } from './app/$owner/agents/$agentId'
import { Route as OwnerEventsEventIdIndexRouteImport } from './app/$owner/events/$eventId/index'
import { Route as OwnerConnectorsCreateIndexRouteImport } from './app/$owner/connectors/create/index'
import { Route as OwnerConnectorsConnectorKeyIndexRouteImport } from './app/$owner/connectors/$connectorKey.index'
import { Route as OwnerChatAgentIdIndexRouteImport } from './app/$owner/chat/$agentId/index'
import { Route as OwnerAgentsConnectIndexRouteImport } from './app/$owner/agents/connect/index'
import { Route as OwnerConnectorsDeviceDeviceIdRouteImport } from './app/$owner/connectors/device.$deviceId'
import { Route as OwnerConnectorsCreateConnectorKeyRouteImport } from './app/$owner/connectors/create.$connectorKey'
import { Route as OwnerConnectorsAppAppIdRouteImport } from './app/$owner/connectors/app.$appId'
import { Route as OwnerConnectorsConnectorKeyConnectionIdRouteImport } from './app/$owner/connectors/$connectorKey.$connectionId'
import { Route as OwnerAgentsConnectedClientIdRouteImport } from './app/$owner/agents/connected.$clientId'
import { Route as OwnerAgentsConnectClientIdRouteImport } from './app/$owner/agents/connect.$clientId'
import { Route as OwnerAgentsAgentIdSkillsRouteImport } from './app/$owner/agents/$agentId/skills'
import { Route as OwnerAgentsAgentIdSettingsRouteImport } from './app/$owner/agents/$agentId/settings'
import { Route as OwnerAgentsAgentIdPermissionsRouteImport } from './app/$owner/agents/$agentId/permissions'
import { Route as OwnerAgentsAgentIdModelsRouteImport } from './app/$owner/agents/$agentId/models'
import { Route as OwnerAgentsAgentIdIdentityRouteImport } from './app/$owner/agents/$agentId/identity'
import { Route as OwnerAgentsAgentIdGuardrailsRouteImport } from './app/$owner/agents/$agentId/guardrails'
import { Route as OwnerEntityTypeChar91Char93ShapeRouteImport } from './app/$owner/$entityType/[-]/$shape'
import { Route as OwnerAgentsConnectedClientIdIndexRouteImport } from './app/$owner/agents/connected.$clientId.index'
import { Route as OwnerAgentsAgentIdSkillsIndexRouteImport } from './app/$owner/agents/$agentId/skills/index'
import { Route as OwnerAgentsAgentIdGuardrailsIndexRouteImport } from './app/$owner/agents/$agentId/guardrails/index'
import { Route as OwnerDataChar91Char93ViewsViewKeyRouteImport } from './app/$owner/data/[-]/views/$viewKey'
import { Route as OwnerChatAgentIdCThreadIdRouteImport } from './app/$owner/chat/$agentId/c/$threadId'
import { Route as OwnerAgentsConnectedClientIdActivityRouteImport } from './app/$owner/agents/connected.$clientId.activity'
import { Route as OwnerAgentsAgentIdSkillsCreateRouteImport } from './app/$owner/agents/$agentId/skills/create'
import { Route as OwnerAgentsAgentIdSkillsSkillKeyRouteImport } from './app/$owner/agents/$agentId/skills/$skillKey'
import { Route as OwnerAgentsAgentIdGuardrailsCreateRouteImport } from './app/$owner/agents/$agentId/guardrails/create'
import { Route as OwnerAgentsAgentIdGuardrailsNameRouteImport } from './app/$owner/agents/$agentId/guardrails/$name'
import { Route as OwnerAgentsAgentIdConversationsConversationIdRouteImport } from './app/$owner/agents/$agentId/conversations/$conversationId'
import { Route as OwnerEntityTypeChar91Char93ViewsViewKeyRouteImport } from './app/$owner/$entityType/[-]/views/$viewKey'
import { Route as OwnerEventsEventIdChar91Char93ViewsViewKeyRouteImport } from './app/$owner/events/$eventId/[-]/views/$viewKey'

const OwnerRoute = OwnerRouteImport.update({
  id: '/$owner',
  path: '/$owner',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OwnerIndexRoute = OwnerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OwnerRoute,
} as any)
const SlackClaimRoute = SlackClaimRouteImport.update({
  id: '/slack/claim',
  path: '/slack/claim',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgsNewRoute = OrgsNewRouteImport.update({
  id: '/orgs/new',
  path: '/orgs/new',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthDeviceRoute = OauthDeviceRouteImport.update({
  id: '/oauth/device',
  path: '/oauth/device',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLogoutRoute = AuthLogoutRouteImport.update({
  id: '/auth/logout',
  path: '/auth/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAcceptInvitationRoute = AuthAcceptInvitationRouteImport.update({
  id: '/auth/accept-invitation',
  path: '/auth/accept-invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountSettingsRoute = AccountSettingsRouteImport.update({
  id: '/account/settings',
  path: '/account/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const OwnerConnectorsRoute = OwnerConnectorsRouteImport.update({
  id: '/connectors',
  path: '/connectors',
  getParentRoute: () => OwnerRoute,
} as any)
const OwnerAutomationsRoute = OwnerAutomationsRouteImport.update({
  id: '/automations',
  path: '/automations',
  getParentRoute: () => OwnerRoute,
} as any)
const OwnerAgentsRoute = OwnerAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => OwnerRoute,
} as any)
const OwnerSplatRoute = OwnerSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => OwnerRoute,
} as any)
const OwnerSettingsIndexRoute = OwnerSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => OwnerRoute,
} as any)
const OwnerMemoryIndexRoute = OwnerMemoryIndexRouteImport.update({
  id: '/memory/',
  path: '/memory/',
  getParentRoute: () => OwnerRoute,
} as any)
const OwnerMembersIndexRoute = OwnerMembersIndexRouteImport.update({
  id: '/members/',
  path: '/members/',
  getParentRoute: () => OwnerRoute,
} as any)
const OwnerEventsIndexRoute = OwnerEventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => OwnerRoute,
} as any)
const OwnerDataIndexRoute = OwnerDataIndexRouteImport.update({
  id: '/data/',
  path: '/data/',
  getParentRoute: () => OwnerRoute,
} as any)
const OwnerConnectorsIndexRoute = OwnerConnectorsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OwnerConnectorsRoute,
} as any)
const OwnerChatIndexRoute = OwnerChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => OwnerRoute,
} as any)
const OwnerAutomationsIndexRoute = OwnerAutomationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OwnerAutomationsRoute,
} as any)
const OwnerAgentsIndexRoute = OwnerAgentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OwnerAgentsRoute,
} as any)
const OwnerEntityTypeIndexRoute = OwnerEntityTypeIndexRouteImport.update({
  id: '/$entityType/',
  path: '/$entityType/',
  getParentRoute: () => OwnerRoute,
} as any)
const ConnectorNameConnectionRoute = ConnectorNameConnectionRouteImport.update({
  id: '/connector/$name/connection',
  path: '/connector/$name/connection',
  getParentRoute: () => rootRouteImport,
} as any)
const OwnerViewsViewRoute = OwnerViewsViewRouteImport.update({
  id: '/views/$view',
  path: '/views/$view',
  getParentRoute: () => OwnerRoute,
} as any)
const OwnerSettingsOrganizationRoute =
  OwnerSettingsOrganizationRouteImport.update({
    id: '/settings/organization',
    path: '/settings/organization',
    getParentRoute: () => OwnerRoute,
  } as any)
const OwnerMemorySplatRoute = OwnerMemorySplatRouteImport.update({
  id: '/memory/$',
  path: '/memory/$',
  getParentRoute: () => OwnerRoute,
} as any)
const OwnerEventsEventIdRoute = OwnerEventsEventIdRouteImport.update({
  id: '/events/$eventId',
  path: '/events/$eventId',
  getParentRoute: () => OwnerRoute,
} as any)
const OwnerEventsSplatRoute = OwnerEventsSplatRouteImport.update({
  id: '/events/$',
  path: '/events/$',
  getParentRoute: () => OwnerRoute,
} as any)
const OwnerEntityTypesNewRoute = OwnerEntityTypesNewRouteImport.update({
  id: '/entity-types/new',
  path: '/entity-types/new',
  getParentRoute: () => OwnerRoute,
} as any)
const OwnerEntityTypesSlugRoute = OwnerEntityTypesSlugRouteImport.update({
  id: '/entity-types/$slug',
  path: '/entity-types/$slug',
  getParentRoute: () => OwnerRoute,
} as any)
const OwnerConnectorsCreateRoute = OwnerConnectorsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => OwnerConnectorsRoute,
} as any)
const OwnerChatAgentIdRoute = OwnerChatAgentIdRouteImport.update({
  id: '/chat/$agentId',
  path: '/chat/$agentId',
  getParentRoute: () => OwnerRoute,
} as any)
const OwnerAutomationsNewRoute = OwnerAutomationsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => OwnerAutomationsRoute,
} as any)
const OwnerAutomationsAutomationIdRoute =
  OwnerAutomationsAutomationIdRouteImport.update({
    id: '/$automationId',
    path: '/$automationId',
    getParentRoute: () => OwnerAutomationsRoute,
  } as any)
const OwnerAgentsNewRoute = OwnerAgentsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => OwnerAgentsRoute,
} as any)
const OwnerAgentsConnectRoute = OwnerAgentsConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => OwnerAgentsRoute,
} as any)
const OwnerAgentsAgentIdRoute = OwnerAgentsAgentIdRouteImport.update({
  id: '/$agentId',
  path: '/$agentId',
  getParentRoute: () => OwnerAgentsRoute,
} as any)
const OwnerEventsEventIdIndexRoute = OwnerEventsEventIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OwnerEventsEventIdRoute,
} as any)
const OwnerConnectorsCreateIndexRoute =
  OwnerConnectorsCreateIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OwnerConnectorsCreateRoute,
  } as any)
const OwnerConnectorsConnectorKeyIndexRoute =
  OwnerConnectorsConnectorKeyIndexRouteImport.update({
    id: '/$connectorKey/',
    path: '/$connectorKey/',
    getParentRoute: () => OwnerConnectorsRoute,
  } as any)
const OwnerChatAgentIdIndexRoute = OwnerChatAgentIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OwnerChatAgentIdRoute,
} as any)
const OwnerAgentsConnectIndexRoute = OwnerAgentsConnectIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OwnerAgentsConnectRoute,
} as any)
const OwnerConnectorsDeviceDeviceIdRoute =
  OwnerConnectorsDeviceDeviceIdRouteImport.update({
    id: '/device/$deviceId',
    path: '/device/$deviceId',
    getParentRoute: () => OwnerConnectorsRoute,
  } as any)
const OwnerConnectorsCreateConnectorKeyRoute =
  OwnerConnectorsCreateConnectorKeyRouteImport.update({
    id: '/$connectorKey',
    path: '/$connectorKey',
    getParentRoute: () => OwnerConnectorsCreateRoute,
  } as any)
const OwnerConnectorsAppAppIdRoute = OwnerConnectorsAppAppIdRouteImport.update({
  id: '/app/$appId',
  path: '/app/$appId',
  getParentRoute: () => OwnerConnectorsRoute,
} as any)
const OwnerConnectorsConnectorKeyConnectionIdRoute =
  OwnerConnectorsConnectorKeyConnectionIdRouteImport.update({
    id: '/$connectorKey/$connectionId',
    path: '/$connectorKey/$connectionId',
    getParentRoute: () => OwnerConnectorsRoute,
  } as any)
const OwnerAgentsConnectedClientIdRoute =
  OwnerAgentsConnectedClientIdRouteImport.update({
    id: '/connected/$clientId',
    path: '/connected/$clientId',
    getParentRoute: () => OwnerAgentsRoute,
  } as any)
const OwnerAgentsConnectClientIdRoute =
  OwnerAgentsConnectClientIdRouteImport.update({
    id: '/$clientId',
    path: '/$clientId',
    getParentRoute: () => OwnerAgentsConnectRoute,
  } as any)
const OwnerAgentsAgentIdSkillsRoute =
  OwnerAgentsAgentIdSkillsRouteImport.update({
    id: '/skills',
    path: '/skills',
    getParentRoute: () => OwnerAgentsAgentIdRoute,
  } as any)
const OwnerAgentsAgentIdSettingsRoute =
  OwnerAgentsAgentIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => OwnerAgentsAgentIdRoute,
  } as any)
const OwnerAgentsAgentIdPermissionsRoute =
  OwnerAgentsAgentIdPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => OwnerAgentsAgentIdRoute,
  } as any)
const OwnerAgentsAgentIdModelsRoute =
  OwnerAgentsAgentIdModelsRouteImport.update({
    id: '/models',
    path: '/models',
    getParentRoute: () => OwnerAgentsAgentIdRoute,
  } as any)
const OwnerAgentsAgentIdIdentityRoute =
  OwnerAgentsAgentIdIdentityRouteImport.update({
    id: '/identity',
    path: '/identity',
    getParentRoute: () => OwnerAgentsAgentIdRoute,
  } as any)
const OwnerAgentsAgentIdGuardrailsRoute =
  OwnerAgentsAgentIdGuardrailsRouteImport.update({
    id: '/guardrails',
    path: '/guardrails',
    getParentRoute: () => OwnerAgentsAgentIdRoute,
  } as any)
const OwnerEntityTypeChar91Char93ShapeRoute =
  OwnerEntityTypeChar91Char93ShapeRouteImport.update({
    id: '/$entityType/-/$shape',
    path: '/$entityType/-/$shape',
    getParentRoute: () => OwnerRoute,
  } as any)
const OwnerAgentsConnectedClientIdIndexRoute =
  OwnerAgentsConnectedClientIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OwnerAgentsConnectedClientIdRoute,
  } as any)
const OwnerAgentsAgentIdSkillsIndexRoute =
  OwnerAgentsAgentIdSkillsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OwnerAgentsAgentIdSkillsRoute,
  } as any)
const OwnerAgentsAgentIdGuardrailsIndexRoute =
  OwnerAgentsAgentIdGuardrailsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OwnerAgentsAgentIdGuardrailsRoute,
  } as any)
const OwnerDataChar91Char93ViewsViewKeyRoute =
  OwnerDataChar91Char93ViewsViewKeyRouteImport.update({
    id: '/data/-/views/$viewKey',
    path: '/data/-/views/$viewKey',
    getParentRoute: () => OwnerRoute,
  } as any)
const OwnerChatAgentIdCThreadIdRoute =
  OwnerChatAgentIdCThreadIdRouteImport.update({
    id: '/c/$threadId',
    path: '/c/$threadId',
    getParentRoute: () => OwnerChatAgentIdRoute,
  } as any)
const OwnerAgentsConnectedClientIdActivityRoute =
  OwnerAgentsConnectedClientIdActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => OwnerAgentsConnectedClientIdRoute,
  } as any)
const OwnerAgentsAgentIdSkillsCreateRoute =
  OwnerAgentsAgentIdSkillsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => OwnerAgentsAgentIdSkillsRoute,
  } as any)
const OwnerAgentsAgentIdSkillsSkillKeyRoute =
  OwnerAgentsAgentIdSkillsSkillKeyRouteImport.update({
    id: '/$skillKey',
    path: '/$skillKey',
    getParentRoute: () => OwnerAgentsAgentIdSkillsRoute,
  } as any)
const OwnerAgentsAgentIdGuardrailsCreateRoute =
  OwnerAgentsAgentIdGuardrailsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => OwnerAgentsAgentIdGuardrailsRoute,
  } as any)
const OwnerAgentsAgentIdGuardrailsNameRoute =
  OwnerAgentsAgentIdGuardrailsNameRouteImport.update({
    id: '/$name',
    path: '/$name',
    getParentRoute: () => OwnerAgentsAgentIdGuardrailsRoute,
  } as any)
const OwnerAgentsAgentIdConversationsConversationIdRoute =
  OwnerAgentsAgentIdConversationsConversationIdRouteImport.update({
    id: '/conversations/$conversationId',
    path: '/conversations/$conversationId',
    getParentRoute: () => OwnerAgentsAgentIdRoute,
  } as any)
const OwnerEntityTypeChar91Char93ViewsViewKeyRoute =
  OwnerEntityTypeChar91Char93ViewsViewKeyRouteImport.update({
    id: '/$entityType/-/views/$viewKey',
    path: '/$entityType/-/views/$viewKey',
    getParentRoute: () => OwnerRoute,
  } as any)
const OwnerEventsEventIdChar91Char93ViewsViewKeyRoute =
  OwnerEventsEventIdChar91Char93ViewsViewKeyRouteImport.update({
    id: '/-/views/$viewKey',
    path: '/-/views/$viewKey',
    getParentRoute: () => OwnerEventsEventIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$owner': typeof OwnerRouteWithChildren
  '/$owner/$': typeof OwnerSplatRoute
  '/$owner/agents': typeof OwnerAgentsRouteWithChildren
  '/$owner/automations': typeof OwnerAutomationsRouteWithChildren
  '/$owner/connectors': typeof OwnerConnectorsRouteWithChildren
  '/account/settings': typeof AccountSettingsRoute
  '/auth/accept-invitation': typeof AuthAcceptInvitationRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/oauth/device': typeof OauthDeviceRoute
  '/orgs/new': typeof OrgsNewRoute
  '/slack/claim': typeof SlackClaimRoute
  '/$owner/': typeof OwnerIndexRoute
  '/$owner/agents/$agentId': typeof OwnerAgentsAgentIdRouteWithChildren
  '/$owner/agents/connect': typeof OwnerAgentsConnectRouteWithChildren
  '/$owner/agents/new': typeof OwnerAgentsNewRoute
  '/$owner/automations/$automationId': typeof OwnerAutomationsAutomationIdRoute
  '/$owner/automations/new': typeof OwnerAutomationsNewRoute
  '/$owner/chat/$agentId': typeof OwnerChatAgentIdRouteWithChildren
  '/$owner/connectors/create': typeof OwnerConnectorsCreateRouteWithChildren
  '/$owner/entity-types/$slug': typeof OwnerEntityTypesSlugRoute
  '/$owner/entity-types/new': typeof OwnerEntityTypesNewRoute
  '/$owner/events/$': typeof OwnerEventsSplatRoute
  '/$owner/events/$eventId': typeof OwnerEventsEventIdRouteWithChildren
  '/$owner/memory/$': typeof OwnerMemorySplatRoute
  '/$owner/settings/organization': typeof OwnerSettingsOrganizationRoute
  '/$owner/views/$view': typeof OwnerViewsViewRoute
  '/connector/$name/connection': typeof ConnectorNameConnectionRoute
  '/$owner/$entityType/': typeof OwnerEntityTypeIndexRoute
  '/$owner/agents/': typeof OwnerAgentsIndexRoute
  '/$owner/automations/': typeof OwnerAutomationsIndexRoute
  '/$owner/chat/': typeof OwnerChatIndexRoute
  '/$owner/connectors/': typeof OwnerConnectorsIndexRoute
  '/$owner/data/': typeof OwnerDataIndexRoute
  '/$owner/events/': typeof OwnerEventsIndexRoute
  '/$owner/members/': typeof OwnerMembersIndexRoute
  '/$owner/memory/': typeof OwnerMemoryIndexRoute
  '/$owner/settings/': typeof OwnerSettingsIndexRoute
  '/$owner/$entityType/-/$shape': typeof OwnerEntityTypeChar91Char93ShapeRoute
  '/$owner/agents/$agentId/guardrails': typeof OwnerAgentsAgentIdGuardrailsRouteWithChildren
  '/$owner/agents/$agentId/identity': typeof OwnerAgentsAgentIdIdentityRoute
  '/$owner/agents/$agentId/models': typeof OwnerAgentsAgentIdModelsRoute
  '/$owner/agents/$agentId/permissions': typeof OwnerAgentsAgentIdPermissionsRoute
  '/$owner/agents/$agentId/settings': typeof OwnerAgentsAgentIdSettingsRoute
  '/$owner/agents/$agentId/skills': typeof OwnerAgentsAgentIdSkillsRouteWithChildren
  '/$owner/agents/connect/$clientId': typeof OwnerAgentsConnectClientIdRoute
  '/$owner/agents/connected/$clientId': typeof OwnerAgentsConnectedClientIdRouteWithChildren
  '/$owner/connectors/$connectorKey/$connectionId': typeof OwnerConnectorsConnectorKeyConnectionIdRoute
  '/$owner/connectors/app/$appId': typeof OwnerConnectorsAppAppIdRoute
  '/$owner/connectors/create/$connectorKey': typeof OwnerConnectorsCreateConnectorKeyRoute
  '/$owner/connectors/device/$deviceId': typeof OwnerConnectorsDeviceDeviceIdRoute
  '/$owner/agents/connect/': typeof OwnerAgentsConnectIndexRoute
  '/$owner/chat/$agentId/': typeof OwnerChatAgentIdIndexRoute
  '/$owner/connectors/$connectorKey/': typeof OwnerConnectorsConnectorKeyIndexRoute
  '/$owner/connectors/create/': typeof OwnerConnectorsCreateIndexRoute
  '/$owner/events/$eventId/': typeof OwnerEventsEventIdIndexRoute
  '/$owner/$entityType/-/views/$viewKey': typeof OwnerEntityTypeChar91Char93ViewsViewKeyRoute
  '/$owner/agents/$agentId/conversations/$conversationId': typeof OwnerAgentsAgentIdConversationsConversationIdRoute
  '/$owner/agents/$agentId/guardrails/$name': typeof OwnerAgentsAgentIdGuardrailsNameRoute
  '/$owner/agents/$agentId/guardrails/create': typeof OwnerAgentsAgentIdGuardrailsCreateRoute
  '/$owner/agents/$agentId/skills/$skillKey': typeof OwnerAgentsAgentIdSkillsSkillKeyRoute
  '/$owner/agents/$agentId/skills/create': typeof OwnerAgentsAgentIdSkillsCreateRoute
  '/$owner/agents/connected/$clientId/activity': typeof OwnerAgentsConnectedClientIdActivityRoute
  '/$owner/chat/$agentId/c/$threadId': typeof OwnerChatAgentIdCThreadIdRoute
  '/$owner/data/-/views/$viewKey': typeof OwnerDataChar91Char93ViewsViewKeyRoute
  '/$owner/agents/$agentId/guardrails/': typeof OwnerAgentsAgentIdGuardrailsIndexRoute
  '/$owner/agents/$agentId/skills/': typeof OwnerAgentsAgentIdSkillsIndexRoute
  '/$owner/agents/connected/$clientId/': typeof OwnerAgentsConnectedClientIdIndexRoute
  '/$owner/events/$eventId/-/views/$viewKey': typeof OwnerEventsEventIdChar91Char93ViewsViewKeyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$owner/$': typeof OwnerSplatRoute
  '/account/settings': typeof AccountSettingsRoute
  '/auth/accept-invitation': typeof AuthAcceptInvitationRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/oauth/device': typeof OauthDeviceRoute
  '/orgs/new': typeof OrgsNewRoute
  '/slack/claim': typeof SlackClaimRoute
  '/$owner': typeof OwnerIndexRoute
  '/$owner/agents/$agentId': typeof OwnerAgentsAgentIdRouteWithChildren
  '/$owner/agents/new': typeof OwnerAgentsNewRoute
  '/$owner/automations/$automationId': typeof OwnerAutomationsAutomationIdRoute
  '/$owner/automations/new': typeof OwnerAutomationsNewRoute
  '/$owner/entity-types/$slug': typeof OwnerEntityTypesSlugRoute
  '/$owner/entity-types/new': typeof OwnerEntityTypesNewRoute
  '/$owner/events/$': typeof OwnerEventsSplatRoute
  '/$owner/memory/$': typeof OwnerMemorySplatRoute
  '/$owner/settings/organization': typeof OwnerSettingsOrganizationRoute
  '/$owner/views/$view': typeof OwnerViewsViewRoute
  '/connector/$name/connection': typeof ConnectorNameConnectionRoute
  '/$owner/$entityType': typeof OwnerEntityTypeIndexRoute
  '/$owner/agents': typeof OwnerAgentsIndexRoute
  '/$owner/automations': typeof OwnerAutomationsIndexRoute
  '/$owner/chat': typeof OwnerChatIndexRoute
  '/$owner/connectors': typeof OwnerConnectorsIndexRoute
  '/$owner/data': typeof OwnerDataIndexRoute
  '/$owner/events': typeof OwnerEventsIndexRoute
  '/$owner/members': typeof OwnerMembersIndexRoute
  '/$owner/memory': typeof OwnerMemoryIndexRoute
  '/$owner/settings': typeof OwnerSettingsIndexRoute
  '/$owner/$entityType/-/$shape': typeof OwnerEntityTypeChar91Char93ShapeRoute
  '/$owner/agents/$agentId/identity': typeof OwnerAgentsAgentIdIdentityRoute
  '/$owner/agents/$agentId/models': typeof OwnerAgentsAgentIdModelsRoute
  '/$owner/agents/$agentId/permissions': typeof OwnerAgentsAgentIdPermissionsRoute
  '/$owner/agents/$agentId/settings': typeof OwnerAgentsAgentIdSettingsRoute
  '/$owner/agents/connect/$clientId': typeof OwnerAgentsConnectClientIdRoute
  '/$owner/connectors/$connectorKey/$connectionId': typeof OwnerConnectorsConnectorKeyConnectionIdRoute
  '/$owner/connectors/app/$appId': typeof OwnerConnectorsAppAppIdRoute
  '/$owner/connectors/create/$connectorKey': typeof OwnerConnectorsCreateConnectorKeyRoute
  '/$owner/connectors/device/$deviceId': typeof OwnerConnectorsDeviceDeviceIdRoute
  '/$owner/agents/connect': typeof OwnerAgentsConnectIndexRoute
  '/$owner/chat/$agentId': typeof OwnerChatAgentIdIndexRoute
  '/$owner/connectors/$connectorKey': typeof OwnerConnectorsConnectorKeyIndexRoute
  '/$owner/connectors/create': typeof OwnerConnectorsCreateIndexRoute
  '/$owner/events/$eventId': typeof OwnerEventsEventIdIndexRoute
  '/$owner/$entityType/-/views/$viewKey': typeof OwnerEntityTypeChar91Char93ViewsViewKeyRoute
  '/$owner/agents/$agentId/conversations/$conversationId': typeof OwnerAgentsAgentIdConversationsConversationIdRoute
  '/$owner/agents/$agentId/guardrails/$name': typeof OwnerAgentsAgentIdGuardrailsNameRoute
  '/$owner/agents/$agentId/guardrails/create': typeof OwnerAgentsAgentIdGuardrailsCreateRoute
  '/$owner/agents/$agentId/skills/$skillKey': typeof OwnerAgentsAgentIdSkillsSkillKeyRoute
  '/$owner/agents/$agentId/skills/create': typeof OwnerAgentsAgentIdSkillsCreateRoute
  '/$owner/agents/connected/$clientId/activity': typeof OwnerAgentsConnectedClientIdActivityRoute
  '/$owner/chat/$agentId/c/$threadId': typeof OwnerChatAgentIdCThreadIdRoute
  '/$owner/data/-/views/$viewKey': typeof OwnerDataChar91Char93ViewsViewKeyRoute
  '/$owner/agents/$agentId/guardrails': typeof OwnerAgentsAgentIdGuardrailsIndexRoute
  '/$owner/agents/$agentId/skills': typeof OwnerAgentsAgentIdSkillsIndexRoute
  '/$owner/agents/connected/$clientId': typeof OwnerAgentsConnectedClientIdIndexRoute
  '/$owner/events/$eventId/-/views/$viewKey': typeof OwnerEventsEventIdChar91Char93ViewsViewKeyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$owner': typeof OwnerRouteWithChildren
  '/$owner/$': typeof OwnerSplatRoute
  '/$owner/agents': typeof OwnerAgentsRouteWithChildren
  '/$owner/automations': typeof OwnerAutomationsRouteWithChildren
  '/$owner/connectors': typeof OwnerConnectorsRouteWithChildren
  '/account/settings': typeof AccountSettingsRoute
  '/auth/accept-invitation': typeof AuthAcceptInvitationRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/oauth/device': typeof OauthDeviceRoute
  '/orgs/new': typeof OrgsNewRoute
  '/slack/claim': typeof SlackClaimRoute
  '/$owner/': typeof OwnerIndexRoute
  '/$owner/agents/$agentId': typeof OwnerAgentsAgentIdRouteWithChildren
  '/$owner/agents/connect': typeof OwnerAgentsConnectRouteWithChildren
  '/$owner/agents/new': typeof OwnerAgentsNewRoute
  '/$owner/automations/$automationId': typeof OwnerAutomationsAutomationIdRoute
  '/$owner/automations/new': typeof OwnerAutomationsNewRoute
  '/$owner/chat/$agentId': typeof OwnerChatAgentIdRouteWithChildren
  '/$owner/connectors/create': typeof OwnerConnectorsCreateRouteWithChildren
  '/$owner/entity-types/$slug': typeof OwnerEntityTypesSlugRoute
  '/$owner/entity-types/new': typeof OwnerEntityTypesNewRoute
  '/$owner/events/$': typeof OwnerEventsSplatRoute
  '/$owner/events/$eventId': typeof OwnerEventsEventIdRouteWithChildren
  '/$owner/memory/$': typeof OwnerMemorySplatRoute
  '/$owner/settings/organization': typeof OwnerSettingsOrganizationRoute
  '/$owner/views/$view': typeof OwnerViewsViewRoute
  '/connector/$name/connection': typeof ConnectorNameConnectionRoute
  '/$owner/$entityType/': typeof OwnerEntityTypeIndexRoute
  '/$owner/agents/': typeof OwnerAgentsIndexRoute
  '/$owner/automations/': typeof OwnerAutomationsIndexRoute
  '/$owner/chat/': typeof OwnerChatIndexRoute
  '/$owner/connectors/': typeof OwnerConnectorsIndexRoute
  '/$owner/data/': typeof OwnerDataIndexRoute
  '/$owner/events/': typeof OwnerEventsIndexRoute
  '/$owner/members/': typeof OwnerMembersIndexRoute
  '/$owner/memory/': typeof OwnerMemoryIndexRoute
  '/$owner/settings/': typeof OwnerSettingsIndexRoute
  '/$owner/$entityType/-/$shape': typeof OwnerEntityTypeChar91Char93ShapeRoute
  '/$owner/agents/$agentId/guardrails': typeof OwnerAgentsAgentIdGuardrailsRouteWithChildren
  '/$owner/agents/$agentId/identity': typeof OwnerAgentsAgentIdIdentityRoute
  '/$owner/agents/$agentId/models': typeof OwnerAgentsAgentIdModelsRoute
  '/$owner/agents/$agentId/permissions': typeof OwnerAgentsAgentIdPermissionsRoute
  '/$owner/agents/$agentId/settings': typeof OwnerAgentsAgentIdSettingsRoute
  '/$owner/agents/$agentId/skills': typeof OwnerAgentsAgentIdSkillsRouteWithChildren
  '/$owner/agents/connect/$clientId': typeof OwnerAgentsConnectClientIdRoute
  '/$owner/agents/connected/$clientId': typeof OwnerAgentsConnectedClientIdRouteWithChildren
  '/$owner/connectors/$connectorKey/$connectionId': typeof OwnerConnectorsConnectorKeyConnectionIdRoute
  '/$owner/connectors/app/$appId': typeof OwnerConnectorsAppAppIdRoute
  '/$owner/connectors/create/$connectorKey': typeof OwnerConnectorsCreateConnectorKeyRoute
  '/$owner/connectors/device/$deviceId': typeof OwnerConnectorsDeviceDeviceIdRoute
  '/$owner/agents/connect/': typeof OwnerAgentsConnectIndexRoute
  '/$owner/chat/$agentId/': typeof OwnerChatAgentIdIndexRoute
  '/$owner/connectors/$connectorKey/': typeof OwnerConnectorsConnectorKeyIndexRoute
  '/$owner/connectors/create/': typeof OwnerConnectorsCreateIndexRoute
  '/$owner/events/$eventId/': typeof OwnerEventsEventIdIndexRoute
  '/$owner/$entityType/-/views/$viewKey': typeof OwnerEntityTypeChar91Char93ViewsViewKeyRoute
  '/$owner/agents/$agentId/conversations/$conversationId': typeof OwnerAgentsAgentIdConversationsConversationIdRoute
  '/$owner/agents/$agentId/guardrails/$name': typeof OwnerAgentsAgentIdGuardrailsNameRoute
  '/$owner/agents/$agentId/guardrails/create': typeof OwnerAgentsAgentIdGuardrailsCreateRoute
  '/$owner/agents/$agentId/skills/$skillKey': typeof OwnerAgentsAgentIdSkillsSkillKeyRoute
  '/$owner/agents/$agentId/skills/create': typeof OwnerAgentsAgentIdSkillsCreateRoute
  '/$owner/agents/connected/$clientId/activity': typeof OwnerAgentsConnectedClientIdActivityRoute
  '/$owner/chat/$agentId/c/$threadId': typeof OwnerChatAgentIdCThreadIdRoute
  '/$owner/data/-/views/$viewKey': typeof OwnerDataChar91Char93ViewsViewKeyRoute
  '/$owner/agents/$agentId/guardrails/': typeof OwnerAgentsAgentIdGuardrailsIndexRoute
  '/$owner/agents/$agentId/skills/': typeof OwnerAgentsAgentIdSkillsIndexRoute
  '/$owner/agents/connected/$clientId/': typeof OwnerAgentsConnectedClientIdIndexRoute
  '/$owner/events/$eventId/-/views/$viewKey': typeof OwnerEventsEventIdChar91Char93ViewsViewKeyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$owner'
    | '/$owner/$'
    | '/$owner/agents'
    | '/$owner/automations'
    | '/$owner/connectors'
    | '/account/settings'
    | '/auth/accept-invitation'
    | '/auth/callback'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/reset-password'
    | '/oauth/consent'
    | '/oauth/device'
    | '/orgs/new'
    | '/slack/claim'
    | '/$owner/'
    | '/$owner/agents/$agentId'
    | '/$owner/agents/connect'
    | '/$owner/agents/new'
    | '/$owner/automations/$automationId'
    | '/$owner/automations/new'
    | '/$owner/chat/$agentId'
    | '/$owner/connectors/create'
    | '/$owner/entity-types/$slug'
    | '/$owner/entity-types/new'
    | '/$owner/events/$'
    | '/$owner/events/$eventId'
    | '/$owner/memory/$'
    | '/$owner/settings/organization'
    | '/$owner/views/$view'
    | '/connector/$name/connection'
    | '/$owner/$entityType/'
    | '/$owner/agents/'
    | '/$owner/automations/'
    | '/$owner/chat/'
    | '/$owner/connectors/'
    | '/$owner/data/'
    | '/$owner/events/'
    | '/$owner/members/'
    | '/$owner/memory/'
    | '/$owner/settings/'
    | '/$owner/$entityType/-/$shape'
    | '/$owner/agents/$agentId/guardrails'
    | '/$owner/agents/$agentId/identity'
    | '/$owner/agents/$agentId/models'
    | '/$owner/agents/$agentId/permissions'
    | '/$owner/agents/$agentId/settings'
    | '/$owner/agents/$agentId/skills'
    | '/$owner/agents/connect/$clientId'
    | '/$owner/agents/connected/$clientId'
    | '/$owner/connectors/$connectorKey/$connectionId'
    | '/$owner/connectors/app/$appId'
    | '/$owner/connectors/create/$connectorKey'
    | '/$owner/connectors/device/$deviceId'
    | '/$owner/agents/connect/'
    | '/$owner/chat/$agentId/'
    | '/$owner/connectors/$connectorKey/'
    | '/$owner/connectors/create/'
    | '/$owner/events/$eventId/'
    | '/$owner/$entityType/-/views/$viewKey'
    | '/$owner/agents/$agentId/conversations/$conversationId'
    | '/$owner/agents/$agentId/guardrails/$name'
    | '/$owner/agents/$agentId/guardrails/create'
    | '/$owner/agents/$agentId/skills/$skillKey'
    | '/$owner/agents/$agentId/skills/create'
    | '/$owner/agents/connected/$clientId/activity'
    | '/$owner/chat/$agentId/c/$threadId'
    | '/$owner/data/-/views/$viewKey'
    | '/$owner/agents/$agentId/guardrails/'
    | '/$owner/agents/$agentId/skills/'
    | '/$owner/agents/connected/$clientId/'
    | '/$owner/events/$eventId/-/views/$viewKey'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$owner/$'
    | '/account/settings'
    | '/auth/accept-invitation'
    | '/auth/callback'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/reset-password'
    | '/oauth/consent'
    | '/oauth/device'
    | '/orgs/new'
    | '/slack/claim'
    | '/$owner'
    | '/$owner/agents/$agentId'
    | '/$owner/agents/new'
    | '/$owner/automations/$automationId'
    | '/$owner/automations/new'
    | '/$owner/entity-types/$slug'
    | '/$owner/entity-types/new'
    | '/$owner/events/$'
    | '/$owner/memory/$'
    | '/$owner/settings/organization'
    | '/$owner/views/$view'
    | '/connector/$name/connection'
    | '/$owner/$entityType'
    | '/$owner/agents'
    | '/$owner/automations'
    | '/$owner/chat'
    | '/$owner/connectors'
    | '/$owner/data'
    | '/$owner/events'
    | '/$owner/members'
    | '/$owner/memory'
    | '/$owner/settings'
    | '/$owner/$entityType/-/$shape'
    | '/$owner/agents/$agentId/identity'
    | '/$owner/agents/$agentId/models'
    | '/$owner/agents/$agentId/permissions'
    | '/$owner/agents/$agentId/settings'
    | '/$owner/agents/connect/$clientId'
    | '/$owner/connectors/$connectorKey/$connectionId'
    | '/$owner/connectors/app/$appId'
    | '/$owner/connectors/create/$connectorKey'
    | '/$owner/connectors/device/$deviceId'
    | '/$owner/agents/connect'
    | '/$owner/chat/$agentId'
    | '/$owner/connectors/$connectorKey'
    | '/$owner/connectors/create'
    | '/$owner/events/$eventId'
    | '/$owner/$entityType/-/views/$viewKey'
    | '/$owner/agents/$agentId/conversations/$conversationId'
    | '/$owner/agents/$agentId/guardrails/$name'
    | '/$owner/agents/$agentId/guardrails/create'
    | '/$owner/agents/$agentId/skills/$skillKey'
    | '/$owner/agents/$agentId/skills/create'
    | '/$owner/agents/connected/$clientId/activity'
    | '/$owner/chat/$agentId/c/$threadId'
    | '/$owner/data/-/views/$viewKey'
    | '/$owner/agents/$agentId/guardrails'
    | '/$owner/agents/$agentId/skills'
    | '/$owner/agents/connected/$clientId'
    | '/$owner/events/$eventId/-/views/$viewKey'
  id:
    | '__root__'
    | '/'
    | '/$owner'
    | '/$owner/$'
    | '/$owner/agents'
    | '/$owner/automations'
    | '/$owner/connectors'
    | '/account/settings'
    | '/auth/accept-invitation'
    | '/auth/callback'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/reset-password'
    | '/oauth/consent'
    | '/oauth/device'
    | '/orgs/new'
    | '/slack/claim'
    | '/$owner/'
    | '/$owner/agents/$agentId'
    | '/$owner/agents/connect'
    | '/$owner/agents/new'
    | '/$owner/automations/$automationId'
    | '/$owner/automations/new'
    | '/$owner/chat/$agentId'
    | '/$owner/connectors/create'
    | '/$owner/entity-types/$slug'
    | '/$owner/entity-types/new'
    | '/$owner/events/$'
    | '/$owner/events/$eventId'
    | '/$owner/memory/$'
    | '/$owner/settings/organization'
    | '/$owner/views/$view'
    | '/connector/$name/connection'
    | '/$owner/$entityType/'
    | '/$owner/agents/'
    | '/$owner/automations/'
    | '/$owner/chat/'
    | '/$owner/connectors/'
    | '/$owner/data/'
    | '/$owner/events/'
    | '/$owner/members/'
    | '/$owner/memory/'
    | '/$owner/settings/'
    | '/$owner/$entityType/-/$shape'
    | '/$owner/agents/$agentId/guardrails'
    | '/$owner/agents/$agentId/identity'
    | '/$owner/agents/$agentId/models'
    | '/$owner/agents/$agentId/permissions'
    | '/$owner/agents/$agentId/settings'
    | '/$owner/agents/$agentId/skills'
    | '/$owner/agents/connect/$clientId'
    | '/$owner/agents/connected/$clientId'
    | '/$owner/connectors/$connectorKey/$connectionId'
    | '/$owner/connectors/app/$appId'
    | '/$owner/connectors/create/$connectorKey'
    | '/$owner/connectors/device/$deviceId'
    | '/$owner/agents/connect/'
    | '/$owner/chat/$agentId/'
    | '/$owner/connectors/$connectorKey/'
    | '/$owner/connectors/create/'
    | '/$owner/events/$eventId/'
    | '/$owner/$entityType/-/views/$viewKey'
    | '/$owner/agents/$agentId/conversations/$conversationId'
    | '/$owner/agents/$agentId/guardrails/$name'
    | '/$owner/agents/$agentId/guardrails/create'
    | '/$owner/agents/$agentId/skills/$skillKey'
    | '/$owner/agents/$agentId/skills/create'
    | '/$owner/agents/connected/$clientId/activity'
    | '/$owner/chat/$agentId/c/$threadId'
    | '/$owner/data/-/views/$viewKey'
    | '/$owner/agents/$agentId/guardrails/'
    | '/$owner/agents/$agentId/skills/'
    | '/$owner/agents/connected/$clientId/'
    | '/$owner/events/$eventId/-/views/$viewKey'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  OwnerRoute: typeof OwnerRouteWithChildren
  AccountSettingsRoute: typeof AccountSettingsRoute
  AuthAcceptInvitationRoute: typeof AuthAcceptInvitationRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthLogoutRoute: typeof AuthLogoutRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  OauthConsentRoute: typeof OauthConsentRoute
  OauthDeviceRoute: typeof OauthDeviceRoute
  OrgsNewRoute: typeof OrgsNewRoute
  SlackClaimRoute: typeof SlackClaimRoute
  ConnectorNameConnectionRoute: typeof ConnectorNameConnectionRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$owner': {
      id: '/$owner'
      path: '/$owner'
      fullPath: '/$owner'
      preLoaderRoute: typeof OwnerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$owner/': {
      id: '/$owner/'
      path: '/'
      fullPath: '/$owner/'
      preLoaderRoute: typeof OwnerIndexRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/slack/claim': {
      id: '/slack/claim'
      path: '/slack/claim'
      fullPath: '/slack/claim'
      preLoaderRoute: typeof SlackClaimRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orgs/new': {
      id: '/orgs/new'
      path: '/orgs/new'
      fullPath: '/orgs/new'
      preLoaderRoute: typeof OrgsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/device': {
      id: '/oauth/device'
      path: '/oauth/device'
      fullPath: '/oauth/device'
      preLoaderRoute: typeof OauthDeviceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/logout': {
      id: '/auth/logout'
      path: '/auth/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof AuthLogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/accept-invitation': {
      id: '/auth/accept-invitation'
      path: '/auth/accept-invitation'
      fullPath: '/auth/accept-invitation'
      preLoaderRoute: typeof AuthAcceptInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/settings': {
      id: '/account/settings'
      path: '/account/settings'
      fullPath: '/account/settings'
      preLoaderRoute: typeof AccountSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$owner/connectors': {
      id: '/$owner/connectors'
      path: '/connectors'
      fullPath: '/$owner/connectors'
      preLoaderRoute: typeof OwnerConnectorsRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/$owner/automations': {
      id: '/$owner/automations'
      path: '/automations'
      fullPath: '/$owner/automations'
      preLoaderRoute: typeof OwnerAutomationsRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/$owner/agents': {
      id: '/$owner/agents'
      path: '/agents'
      fullPath: '/$owner/agents'
      preLoaderRoute: typeof OwnerAgentsRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/$owner/$': {
      id: '/$owner/$'
      path: '/$'
      fullPath: '/$owner/$'
      preLoaderRoute: typeof OwnerSplatRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/$owner/settings/': {
      id: '/$owner/settings/'
      path: '/settings'
      fullPath: '/$owner/settings/'
      preLoaderRoute: typeof OwnerSettingsIndexRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/$owner/memory/': {
      id: '/$owner/memory/'
      path: '/memory'
      fullPath: '/$owner/memory/'
      preLoaderRoute: typeof OwnerMemoryIndexRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/$owner/members/': {
      id: '/$owner/members/'
      path: '/members'
      fullPath: '/$owner/members/'
      preLoaderRoute: typeof OwnerMembersIndexRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/$owner/events/': {
      id: '/$owner/events/'
      path: '/events'
      fullPath: '/$owner/events/'
      preLoaderRoute: typeof OwnerEventsIndexRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/$owner/data/': {
      id: '/$owner/data/'
      path: '/data'
      fullPath: '/$owner/data/'
      preLoaderRoute: typeof OwnerDataIndexRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/$owner/connectors/': {
      id: '/$owner/connectors/'
      path: '/'
      fullPath: '/$owner/connectors/'
      preLoaderRoute: typeof OwnerConnectorsIndexRouteImport
      parentRoute: typeof OwnerConnectorsRoute
    }
    '/$owner/chat/': {
      id: '/$owner/chat/'
      path: '/chat'
      fullPath: '/$owner/chat/'
      preLoaderRoute: typeof OwnerChatIndexRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/$owner/automations/': {
      id: '/$owner/automations/'
      path: '/'
      fullPath: '/$owner/automations/'
      preLoaderRoute: typeof OwnerAutomationsIndexRouteImport
      parentRoute: typeof OwnerAutomationsRoute
    }
    '/$owner/agents/': {
      id: '/$owner/agents/'
      path: '/'
      fullPath: '/$owner/agents/'
      preLoaderRoute: typeof OwnerAgentsIndexRouteImport
      parentRoute: typeof OwnerAgentsRoute
    }
    '/$owner/$entityType/': {
      id: '/$owner/$entityType/'
      path: '/$entityType'
      fullPath: '/$owner/$entityType/'
      preLoaderRoute: typeof OwnerEntityTypeIndexRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/connector/$name/connection': {
      id: '/connector/$name/connection'
      path: '/connector/$name/connection'
      fullPath: '/connector/$name/connection'
      preLoaderRoute: typeof ConnectorNameConnectionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$owner/views/$view': {
      id: '/$owner/views/$view'
      path: '/views/$view'
      fullPath: '/$owner/views/$view'
      preLoaderRoute: typeof OwnerViewsViewRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/$owner/settings/organization': {
      id: '/$owner/settings/organization'
      path: '/settings/organization'
      fullPath: '/$owner/settings/organization'
      preLoaderRoute: typeof OwnerSettingsOrganizationRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/$owner/memory/$': {
      id: '/$owner/memory/$'
      path: '/memory/$'
      fullPath: '/$owner/memory/$'
      preLoaderRoute: typeof OwnerMemorySplatRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/$owner/events/$eventId': {
      id: '/$owner/events/$eventId'
      path: '/events/$eventId'
      fullPath: '/$owner/events/$eventId'
      preLoaderRoute: typeof OwnerEventsEventIdRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/$owner/events/$': {
      id: '/$owner/events/$'
      path: '/events/$'
      fullPath: '/$owner/events/$'
      preLoaderRoute: typeof OwnerEventsSplatRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/$owner/entity-types/new': {
      id: '/$owner/entity-types/new'
      path: '/entity-types/new'
      fullPath: '/$owner/entity-types/new'
      preLoaderRoute: typeof OwnerEntityTypesNewRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/$owner/entity-types/$slug': {
      id: '/$owner/entity-types/$slug'
      path: '/entity-types/$slug'
      fullPath: '/$owner/entity-types/$slug'
      preLoaderRoute: typeof OwnerEntityTypesSlugRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/$owner/connectors/create': {
      id: '/$owner/connectors/create'
      path: '/create'
      fullPath: '/$owner/connectors/create'
      preLoaderRoute: typeof OwnerConnectorsCreateRouteImport
      parentRoute: typeof OwnerConnectorsRoute
    }
    '/$owner/chat/$agentId': {
      id: '/$owner/chat/$agentId'
      path: '/chat/$agentId'
      fullPath: '/$owner/chat/$agentId'
      preLoaderRoute: typeof OwnerChatAgentIdRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/$owner/automations/new': {
      id: '/$owner/automations/new'
      path: '/new'
      fullPath: '/$owner/automations/new'
      preLoaderRoute: typeof OwnerAutomationsNewRouteImport
      parentRoute: typeof OwnerAutomationsRoute
    }
    '/$owner/automations/$automationId': {
      id: '/$owner/automations/$automationId'
      path: '/$automationId'
      fullPath: '/$owner/automations/$automationId'
      preLoaderRoute: typeof OwnerAutomationsAutomationIdRouteImport
      parentRoute: typeof OwnerAutomationsRoute
    }
    '/$owner/agents/new': {
      id: '/$owner/agents/new'
      path: '/new'
      fullPath: '/$owner/agents/new'
      preLoaderRoute: typeof OwnerAgentsNewRouteImport
      parentRoute: typeof OwnerAgentsRoute
    }
    '/$owner/agents/connect': {
      id: '/$owner/agents/connect'
      path: '/connect'
      fullPath: '/$owner/agents/connect'
      preLoaderRoute: typeof OwnerAgentsConnectRouteImport
      parentRoute: typeof OwnerAgentsRoute
    }
    '/$owner/agents/$agentId': {
      id: '/$owner/agents/$agentId'
      path: '/$agentId'
      fullPath: '/$owner/agents/$agentId'
      preLoaderRoute: typeof OwnerAgentsAgentIdRouteImport
      parentRoute: typeof OwnerAgentsRoute
    }
    '/$owner/events/$eventId/': {
      id: '/$owner/events/$eventId/'
      path: '/'
      fullPath: '/$owner/events/$eventId/'
      preLoaderRoute: typeof OwnerEventsEventIdIndexRouteImport
      parentRoute: typeof OwnerEventsEventIdRoute
    }
    '/$owner/connectors/create/': {
      id: '/$owner/connectors/create/'
      path: '/'
      fullPath: '/$owner/connectors/create/'
      preLoaderRoute: typeof OwnerConnectorsCreateIndexRouteImport
      parentRoute: typeof OwnerConnectorsCreateRoute
    }
    '/$owner/connectors/$connectorKey/': {
      id: '/$owner/connectors/$connectorKey/'
      path: '/$connectorKey'
      fullPath: '/$owner/connectors/$connectorKey/'
      preLoaderRoute: typeof OwnerConnectorsConnectorKeyIndexRouteImport
      parentRoute: typeof OwnerConnectorsRoute
    }
    '/$owner/chat/$agentId/': {
      id: '/$owner/chat/$agentId/'
      path: '/'
      fullPath: '/$owner/chat/$agentId/'
      preLoaderRoute: typeof OwnerChatAgentIdIndexRouteImport
      parentRoute: typeof OwnerChatAgentIdRoute
    }
    '/$owner/agents/connect/': {
      id: '/$owner/agents/connect/'
      path: '/'
      fullPath: '/$owner/agents/connect/'
      preLoaderRoute: typeof OwnerAgentsConnectIndexRouteImport
      parentRoute: typeof OwnerAgentsConnectRoute
    }
    '/$owner/connectors/device/$deviceId': {
      id: '/$owner/connectors/device/$deviceId'
      path: '/device/$deviceId'
      fullPath: '/$owner/connectors/device/$deviceId'
      preLoaderRoute: typeof OwnerConnectorsDeviceDeviceIdRouteImport
      parentRoute: typeof OwnerConnectorsRoute
    }
    '/$owner/connectors/create/$connectorKey': {
      id: '/$owner/connectors/create/$connectorKey'
      path: '/$connectorKey'
      fullPath: '/$owner/connectors/create/$connectorKey'
      preLoaderRoute: typeof OwnerConnectorsCreateConnectorKeyRouteImport
      parentRoute: typeof OwnerConnectorsCreateRoute
    }
    '/$owner/connectors/app/$appId': {
      id: '/$owner/connectors/app/$appId'
      path: '/app/$appId'
      fullPath: '/$owner/connectors/app/$appId'
      preLoaderRoute: typeof OwnerConnectorsAppAppIdRouteImport
      parentRoute: typeof OwnerConnectorsRoute
    }
    '/$owner/connectors/$connectorKey/$connectionId': {
      id: '/$owner/connectors/$connectorKey/$connectionId'
      path: '/$connectorKey/$connectionId'
      fullPath: '/$owner/connectors/$connectorKey/$connectionId'
      preLoaderRoute: typeof OwnerConnectorsConnectorKeyConnectionIdRouteImport
      parentRoute: typeof OwnerConnectorsRoute
    }
    '/$owner/agents/connected/$clientId': {
      id: '/$owner/agents/connected/$clientId'
      path: '/connected/$clientId'
      fullPath: '/$owner/agents/connected/$clientId'
      preLoaderRoute: typeof OwnerAgentsConnectedClientIdRouteImport
      parentRoute: typeof OwnerAgentsRoute
    }
    '/$owner/agents/connect/$clientId': {
      id: '/$owner/agents/connect/$clientId'
      path: '/$clientId'
      fullPath: '/$owner/agents/connect/$clientId'
      preLoaderRoute: typeof OwnerAgentsConnectClientIdRouteImport
      parentRoute: typeof OwnerAgentsConnectRoute
    }
    '/$owner/agents/$agentId/skills': {
      id: '/$owner/agents/$agentId/skills'
      path: '/skills'
      fullPath: '/$owner/agents/$agentId/skills'
      preLoaderRoute: typeof OwnerAgentsAgentIdSkillsRouteImport
      parentRoute: typeof OwnerAgentsAgentIdRoute
    }
    '/$owner/agents/$agentId/settings': {
      id: '/$owner/agents/$agentId/settings'
      path: '/settings'
      fullPath: '/$owner/agents/$agentId/settings'
      preLoaderRoute: typeof OwnerAgentsAgentIdSettingsRouteImport
      parentRoute: typeof OwnerAgentsAgentIdRoute
    }
    '/$owner/agents/$agentId/permissions': {
      id: '/$owner/agents/$agentId/permissions'
      path: '/permissions'
      fullPath: '/$owner/agents/$agentId/permissions'
      preLoaderRoute: typeof OwnerAgentsAgentIdPermissionsRouteImport
      parentRoute: typeof OwnerAgentsAgentIdRoute
    }
    '/$owner/agents/$agentId/models': {
      id: '/$owner/agents/$agentId/models'
      path: '/models'
      fullPath: '/$owner/agents/$agentId/models'
      preLoaderRoute: typeof OwnerAgentsAgentIdModelsRouteImport
      parentRoute: typeof OwnerAgentsAgentIdRoute
    }
    '/$owner/agents/$agentId/identity': {
      id: '/$owner/agents/$agentId/identity'
      path: '/identity'
      fullPath: '/$owner/agents/$agentId/identity'
      preLoaderRoute: typeof OwnerAgentsAgentIdIdentityRouteImport
      parentRoute: typeof OwnerAgentsAgentIdRoute
    }
    '/$owner/agents/$agentId/guardrails': {
      id: '/$owner/agents/$agentId/guardrails'
      path: '/guardrails'
      fullPath: '/$owner/agents/$agentId/guardrails'
      preLoaderRoute: typeof OwnerAgentsAgentIdGuardrailsRouteImport
      parentRoute: typeof OwnerAgentsAgentIdRoute
    }
    '/$owner/$entityType/-/$shape': {
      id: '/$owner/$entityType/-/$shape'
      path: '/$entityType/-/$shape'
      fullPath: '/$owner/$entityType/-/$shape'
      preLoaderRoute: typeof OwnerEntityTypeChar91Char93ShapeRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/$owner/agents/connected/$clientId/': {
      id: '/$owner/agents/connected/$clientId/'
      path: '/'
      fullPath: '/$owner/agents/connected/$clientId/'
      preLoaderRoute: typeof OwnerAgentsConnectedClientIdIndexRouteImport
      parentRoute: typeof OwnerAgentsConnectedClientIdRoute
    }
    '/$owner/agents/$agentId/skills/': {
      id: '/$owner/agents/$agentId/skills/'
      path: '/'
      fullPath: '/$owner/agents/$agentId/skills/'
      preLoaderRoute: typeof OwnerAgentsAgentIdSkillsIndexRouteImport
      parentRoute: typeof OwnerAgentsAgentIdSkillsRoute
    }
    '/$owner/agents/$agentId/guardrails/': {
      id: '/$owner/agents/$agentId/guardrails/'
      path: '/'
      fullPath: '/$owner/agents/$agentId/guardrails/'
      preLoaderRoute: typeof OwnerAgentsAgentIdGuardrailsIndexRouteImport
      parentRoute: typeof OwnerAgentsAgentIdGuardrailsRoute
    }
    '/$owner/data/-/views/$viewKey': {
      id: '/$owner/data/-/views/$viewKey'
      path: '/data/-/views/$viewKey'
      fullPath: '/$owner/data/-/views/$viewKey'
      preLoaderRoute: typeof OwnerDataChar91Char93ViewsViewKeyRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/$owner/chat/$agentId/c/$threadId': {
      id: '/$owner/chat/$agentId/c/$threadId'
      path: '/c/$threadId'
      fullPath: '/$owner/chat/$agentId/c/$threadId'
      preLoaderRoute: typeof OwnerChatAgentIdCThreadIdRouteImport
      parentRoute: typeof OwnerChatAgentIdRoute
    }
    '/$owner/agents/connected/$clientId/activity': {
      id: '/$owner/agents/connected/$clientId/activity'
      path: '/activity'
      fullPath: '/$owner/agents/connected/$clientId/activity'
      preLoaderRoute: typeof OwnerAgentsConnectedClientIdActivityRouteImport
      parentRoute: typeof OwnerAgentsConnectedClientIdRoute
    }
    '/$owner/agents/$agentId/skills/create': {
      id: '/$owner/agents/$agentId/skills/create'
      path: '/create'
      fullPath: '/$owner/agents/$agentId/skills/create'
      preLoaderRoute: typeof OwnerAgentsAgentIdSkillsCreateRouteImport
      parentRoute: typeof OwnerAgentsAgentIdSkillsRoute
    }
    '/$owner/agents/$agentId/skills/$skillKey': {
      id: '/$owner/agents/$agentId/skills/$skillKey'
      path: '/$skillKey'
      fullPath: '/$owner/agents/$agentId/skills/$skillKey'
      preLoaderRoute: typeof OwnerAgentsAgentIdSkillsSkillKeyRouteImport
      parentRoute: typeof OwnerAgentsAgentIdSkillsRoute
    }
    '/$owner/agents/$agentId/guardrails/create': {
      id: '/$owner/agents/$agentId/guardrails/create'
      path: '/create'
      fullPath: '/$owner/agents/$agentId/guardrails/create'
      preLoaderRoute: typeof OwnerAgentsAgentIdGuardrailsCreateRouteImport
      parentRoute: typeof OwnerAgentsAgentIdGuardrailsRoute
    }
    '/$owner/agents/$agentId/guardrails/$name': {
      id: '/$owner/agents/$agentId/guardrails/$name'
      path: '/$name'
      fullPath: '/$owner/agents/$agentId/guardrails/$name'
      preLoaderRoute: typeof OwnerAgentsAgentIdGuardrailsNameRouteImport
      parentRoute: typeof OwnerAgentsAgentIdGuardrailsRoute
    }
    '/$owner/agents/$agentId/conversations/$conversationId': {
      id: '/$owner/agents/$agentId/conversations/$conversationId'
      path: '/conversations/$conversationId'
      fullPath: '/$owner/agents/$agentId/conversations/$conversationId'
      preLoaderRoute: typeof OwnerAgentsAgentIdConversationsConversationIdRouteImport
      parentRoute: typeof OwnerAgentsAgentIdRoute
    }
    '/$owner/$entityType/-/views/$viewKey': {
      id: '/$owner/$entityType/-/views/$viewKey'
      path: '/$entityType/-/views/$viewKey'
      fullPath: '/$owner/$entityType/-/views/$viewKey'
      preLoaderRoute: typeof OwnerEntityTypeChar91Char93ViewsViewKeyRouteImport
      parentRoute: typeof OwnerRoute
    }
    '/$owner/events/$eventId/-/views/$viewKey': {
      id: '/$owner/events/$eventId/-/views/$viewKey'
      path: '/-/views/$viewKey'
      fullPath: '/$owner/events/$eventId/-/views/$viewKey'
      preLoaderRoute: typeof OwnerEventsEventIdChar91Char93ViewsViewKeyRouteImport
      parentRoute: typeof OwnerEventsEventIdRoute
    }
  }
}

interface OwnerAgentsAgentIdGuardrailsRouteChildren {
  OwnerAgentsAgentIdGuardrailsNameRoute: typeof OwnerAgentsAgentIdGuardrailsNameRoute
  OwnerAgentsAgentIdGuardrailsCreateRoute: typeof OwnerAgentsAgentIdGuardrailsCreateRoute
  OwnerAgentsAgentIdGuardrailsIndexRoute: typeof OwnerAgentsAgentIdGuardrailsIndexRoute
}

const OwnerAgentsAgentIdGuardrailsRouteChildren: OwnerAgentsAgentIdGuardrailsRouteChildren =
  {
    OwnerAgentsAgentIdGuardrailsNameRoute:
      OwnerAgentsAgentIdGuardrailsNameRoute,
    OwnerAgentsAgentIdGuardrailsCreateRoute:
      OwnerAgentsAgentIdGuardrailsCreateRoute,
    OwnerAgentsAgentIdGuardrailsIndexRoute:
      OwnerAgentsAgentIdGuardrailsIndexRoute,
  }

const OwnerAgentsAgentIdGuardrailsRouteWithChildren =
  OwnerAgentsAgentIdGuardrailsRoute._addFileChildren(
    OwnerAgentsAgentIdGuardrailsRouteChildren,
  )

interface OwnerAgentsAgentIdSkillsRouteChildren {
  OwnerAgentsAgentIdSkillsSkillKeyRoute: typeof OwnerAgentsAgentIdSkillsSkillKeyRoute
  OwnerAgentsAgentIdSkillsCreateRoute: typeof OwnerAgentsAgentIdSkillsCreateRoute
  OwnerAgentsAgentIdSkillsIndexRoute: typeof OwnerAgentsAgentIdSkillsIndexRoute
}

const OwnerAgentsAgentIdSkillsRouteChildren: OwnerAgentsAgentIdSkillsRouteChildren =
  {
    OwnerAgentsAgentIdSkillsSkillKeyRoute:
      OwnerAgentsAgentIdSkillsSkillKeyRoute,
    OwnerAgentsAgentIdSkillsCreateRoute: OwnerAgentsAgentIdSkillsCreateRoute,
    OwnerAgentsAgentIdSkillsIndexRoute: OwnerAgentsAgentIdSkillsIndexRoute,
  }

const OwnerAgentsAgentIdSkillsRouteWithChildren =
  OwnerAgentsAgentIdSkillsRoute._addFileChildren(
    OwnerAgentsAgentIdSkillsRouteChildren,
  )

interface OwnerAgentsAgentIdRouteChildren {
  OwnerAgentsAgentIdGuardrailsRoute: typeof OwnerAgentsAgentIdGuardrailsRouteWithChildren
  OwnerAgentsAgentIdIdentityRoute: typeof OwnerAgentsAgentIdIdentityRoute
  OwnerAgentsAgentIdModelsRoute: typeof OwnerAgentsAgentIdModelsRoute
  OwnerAgentsAgentIdPermissionsRoute: typeof OwnerAgentsAgentIdPermissionsRoute
  OwnerAgentsAgentIdSettingsRoute: typeof OwnerAgentsAgentIdSettingsRoute
  OwnerAgentsAgentIdSkillsRoute: typeof OwnerAgentsAgentIdSkillsRouteWithChildren
  OwnerAgentsAgentIdConversationsConversationIdRoute: typeof OwnerAgentsAgentIdConversationsConversationIdRoute
}

const OwnerAgentsAgentIdRouteChildren: OwnerAgentsAgentIdRouteChildren = {
  OwnerAgentsAgentIdGuardrailsRoute:
    OwnerAgentsAgentIdGuardrailsRouteWithChildren,
  OwnerAgentsAgentIdIdentityRoute: OwnerAgentsAgentIdIdentityRoute,
  OwnerAgentsAgentIdModelsRoute: OwnerAgentsAgentIdModelsRoute,
  OwnerAgentsAgentIdPermissionsRoute: OwnerAgentsAgentIdPermissionsRoute,
  OwnerAgentsAgentIdSettingsRoute: OwnerAgentsAgentIdSettingsRoute,
  OwnerAgentsAgentIdSkillsRoute: OwnerAgentsAgentIdSkillsRouteWithChildren,
  OwnerAgentsAgentIdConversationsConversationIdRoute:
    OwnerAgentsAgentIdConversationsConversationIdRoute,
}

const OwnerAgentsAgentIdRouteWithChildren =
  OwnerAgentsAgentIdRoute._addFileChildren(OwnerAgentsAgentIdRouteChildren)

interface OwnerAgentsConnectRouteChildren {
  OwnerAgentsConnectClientIdRoute: typeof OwnerAgentsConnectClientIdRoute
  OwnerAgentsConnectIndexRoute: typeof OwnerAgentsConnectIndexRoute
}

const OwnerAgentsConnectRouteChildren: OwnerAgentsConnectRouteChildren = {
  OwnerAgentsConnectClientIdRoute: OwnerAgentsConnectClientIdRoute,
  OwnerAgentsConnectIndexRoute: OwnerAgentsConnectIndexRoute,
}

const OwnerAgentsConnectRouteWithChildren =
  OwnerAgentsConnectRoute._addFileChildren(OwnerAgentsConnectRouteChildren)

interface OwnerAgentsConnectedClientIdRouteChildren {
  OwnerAgentsConnectedClientIdActivityRoute: typeof OwnerAgentsConnectedClientIdActivityRoute
  OwnerAgentsConnectedClientIdIndexRoute: typeof OwnerAgentsConnectedClientIdIndexRoute
}

const OwnerAgentsConnectedClientIdRouteChildren: OwnerAgentsConnectedClientIdRouteChildren =
  {
    OwnerAgentsConnectedClientIdActivityRoute:
      OwnerAgentsConnectedClientIdActivityRoute,
    OwnerAgentsConnectedClientIdIndexRoute:
      OwnerAgentsConnectedClientIdIndexRoute,
  }

const OwnerAgentsConnectedClientIdRouteWithChildren =
  OwnerAgentsConnectedClientIdRoute._addFileChildren(
    OwnerAgentsConnectedClientIdRouteChildren,
  )

interface OwnerAgentsRouteChildren {
  OwnerAgentsAgentIdRoute: typeof OwnerAgentsAgentIdRouteWithChildren
  OwnerAgentsConnectRoute: typeof OwnerAgentsConnectRouteWithChildren
  OwnerAgentsNewRoute: typeof OwnerAgentsNewRoute
  OwnerAgentsIndexRoute: typeof OwnerAgentsIndexRoute
  OwnerAgentsConnectedClientIdRoute: typeof OwnerAgentsConnectedClientIdRouteWithChildren
}

const OwnerAgentsRouteChildren: OwnerAgentsRouteChildren = {
  OwnerAgentsAgentIdRoute: OwnerAgentsAgentIdRouteWithChildren,
  OwnerAgentsConnectRoute: OwnerAgentsConnectRouteWithChildren,
  OwnerAgentsNewRoute: OwnerAgentsNewRoute,
  OwnerAgentsIndexRoute: OwnerAgentsIndexRoute,
  OwnerAgentsConnectedClientIdRoute:
    OwnerAgentsConnectedClientIdRouteWithChildren,
}

const OwnerAgentsRouteWithChildren = OwnerAgentsRoute._addFileChildren(
  OwnerAgentsRouteChildren,
)

interface OwnerAutomationsRouteChildren {
  OwnerAutomationsAutomationIdRoute: typeof OwnerAutomationsAutomationIdRoute
  OwnerAutomationsNewRoute: typeof OwnerAutomationsNewRoute
  OwnerAutomationsIndexRoute: typeof OwnerAutomationsIndexRoute
}

const OwnerAutomationsRouteChildren: OwnerAutomationsRouteChildren = {
  OwnerAutomationsAutomationIdRoute: OwnerAutomationsAutomationIdRoute,
  OwnerAutomationsNewRoute: OwnerAutomationsNewRoute,
  OwnerAutomationsIndexRoute: OwnerAutomationsIndexRoute,
}

const OwnerAutomationsRouteWithChildren =
  OwnerAutomationsRoute._addFileChildren(OwnerAutomationsRouteChildren)

interface OwnerConnectorsCreateRouteChildren {
  OwnerConnectorsCreateConnectorKeyRoute: typeof OwnerConnectorsCreateConnectorKeyRoute
  OwnerConnectorsCreateIndexRoute: typeof OwnerConnectorsCreateIndexRoute
}

const OwnerConnectorsCreateRouteChildren: OwnerConnectorsCreateRouteChildren = {
  OwnerConnectorsCreateConnectorKeyRoute:
    OwnerConnectorsCreateConnectorKeyRoute,
  OwnerConnectorsCreateIndexRoute: OwnerConnectorsCreateIndexRoute,
}

const OwnerConnectorsCreateRouteWithChildren =
  OwnerConnectorsCreateRoute._addFileChildren(
    OwnerConnectorsCreateRouteChildren,
  )

interface OwnerConnectorsRouteChildren {
  OwnerConnectorsCreateRoute: typeof OwnerConnectorsCreateRouteWithChildren
  OwnerConnectorsIndexRoute: typeof OwnerConnectorsIndexRoute
  OwnerConnectorsConnectorKeyConnectionIdRoute: typeof OwnerConnectorsConnectorKeyConnectionIdRoute
  OwnerConnectorsAppAppIdRoute: typeof OwnerConnectorsAppAppIdRoute
  OwnerConnectorsDeviceDeviceIdRoute: typeof OwnerConnectorsDeviceDeviceIdRoute
  OwnerConnectorsConnectorKeyIndexRoute: typeof OwnerConnectorsConnectorKeyIndexRoute
}

const OwnerConnectorsRouteChildren: OwnerConnectorsRouteChildren = {
  OwnerConnectorsCreateRoute: OwnerConnectorsCreateRouteWithChildren,
  OwnerConnectorsIndexRoute: OwnerConnectorsIndexRoute,
  OwnerConnectorsConnectorKeyConnectionIdRoute:
    OwnerConnectorsConnectorKeyConnectionIdRoute,
  OwnerConnectorsAppAppIdRoute: OwnerConnectorsAppAppIdRoute,
  OwnerConnectorsDeviceDeviceIdRoute: OwnerConnectorsDeviceDeviceIdRoute,
  OwnerConnectorsConnectorKeyIndexRoute: OwnerConnectorsConnectorKeyIndexRoute,
}

const OwnerConnectorsRouteWithChildren = OwnerConnectorsRoute._addFileChildren(
  OwnerConnectorsRouteChildren,
)

interface OwnerChatAgentIdRouteChildren {
  OwnerChatAgentIdIndexRoute: typeof OwnerChatAgentIdIndexRoute
  OwnerChatAgentIdCThreadIdRoute: typeof OwnerChatAgentIdCThreadIdRoute
}

const OwnerChatAgentIdRouteChildren: OwnerChatAgentIdRouteChildren = {
  OwnerChatAgentIdIndexRoute: OwnerChatAgentIdIndexRoute,
  OwnerChatAgentIdCThreadIdRoute: OwnerChatAgentIdCThreadIdRoute,
}

const OwnerChatAgentIdRouteWithChildren =
  OwnerChatAgentIdRoute._addFileChildren(OwnerChatAgentIdRouteChildren)

interface OwnerEventsEventIdRouteChildren {
  OwnerEventsEventIdIndexRoute: typeof OwnerEventsEventIdIndexRoute
  OwnerEventsEventIdChar91Char93ViewsViewKeyRoute: typeof OwnerEventsEventIdChar91Char93ViewsViewKeyRoute
}

const OwnerEventsEventIdRouteChildren: OwnerEventsEventIdRouteChildren = {
  OwnerEventsEventIdIndexRoute: OwnerEventsEventIdIndexRoute,
  OwnerEventsEventIdChar91Char93ViewsViewKeyRoute:
    OwnerEventsEventIdChar91Char93ViewsViewKeyRoute,
}

const OwnerEventsEventIdRouteWithChildren =
  OwnerEventsEventIdRoute._addFileChildren(OwnerEventsEventIdRouteChildren)

interface OwnerRouteChildren {
  OwnerSplatRoute: typeof OwnerSplatRoute
  OwnerAgentsRoute: typeof OwnerAgentsRouteWithChildren
  OwnerAutomationsRoute: typeof OwnerAutomationsRouteWithChildren
  OwnerConnectorsRoute: typeof OwnerConnectorsRouteWithChildren
  OwnerIndexRoute: typeof OwnerIndexRoute
  OwnerChatAgentIdRoute: typeof OwnerChatAgentIdRouteWithChildren
  OwnerEntityTypesSlugRoute: typeof OwnerEntityTypesSlugRoute
  OwnerEntityTypesNewRoute: typeof OwnerEntityTypesNewRoute
  OwnerEventsSplatRoute: typeof OwnerEventsSplatRoute
  OwnerEventsEventIdRoute: typeof OwnerEventsEventIdRouteWithChildren
  OwnerMemorySplatRoute: typeof OwnerMemorySplatRoute
  OwnerSettingsOrganizationRoute: typeof OwnerSettingsOrganizationRoute
  OwnerViewsViewRoute: typeof OwnerViewsViewRoute
  OwnerEntityTypeIndexRoute: typeof OwnerEntityTypeIndexRoute
  OwnerChatIndexRoute: typeof OwnerChatIndexRoute
  OwnerDataIndexRoute: typeof OwnerDataIndexRoute
  OwnerEventsIndexRoute: typeof OwnerEventsIndexRoute
  OwnerMembersIndexRoute: typeof OwnerMembersIndexRoute
  OwnerMemoryIndexRoute: typeof OwnerMemoryIndexRoute
  OwnerSettingsIndexRoute: typeof OwnerSettingsIndexRoute
  OwnerEntityTypeChar91Char93ShapeRoute: typeof OwnerEntityTypeChar91Char93ShapeRoute
  OwnerEntityTypeChar91Char93ViewsViewKeyRoute: typeof OwnerEntityTypeChar91Char93ViewsViewKeyRoute
  OwnerDataChar91Char93ViewsViewKeyRoute: typeof OwnerDataChar91Char93ViewsViewKeyRoute
}

const OwnerRouteChildren: OwnerRouteChildren = {
  OwnerSplatRoute: OwnerSplatRoute,
  OwnerAgentsRoute: OwnerAgentsRouteWithChildren,
  OwnerAutomationsRoute: OwnerAutomationsRouteWithChildren,
  OwnerConnectorsRoute: OwnerConnectorsRouteWithChildren,
  OwnerIndexRoute: OwnerIndexRoute,
  OwnerChatAgentIdRoute: OwnerChatAgentIdRouteWithChildren,
  OwnerEntityTypesSlugRoute: OwnerEntityTypesSlugRoute,
  OwnerEntityTypesNewRoute: OwnerEntityTypesNewRoute,
  OwnerEventsSplatRoute: OwnerEventsSplatRoute,
  OwnerEventsEventIdRoute: OwnerEventsEventIdRouteWithChildren,
  OwnerMemorySplatRoute: OwnerMemorySplatRoute,
  OwnerSettingsOrganizationRoute: OwnerSettingsOrganizationRoute,
  OwnerViewsViewRoute: OwnerViewsViewRoute,
  OwnerEntityTypeIndexRoute: OwnerEntityTypeIndexRoute,
  OwnerChatIndexRoute: OwnerChatIndexRoute,
  OwnerDataIndexRoute: OwnerDataIndexRoute,
  OwnerEventsIndexRoute: OwnerEventsIndexRoute,
  OwnerMembersIndexRoute: OwnerMembersIndexRoute,
  OwnerMemoryIndexRoute: OwnerMemoryIndexRoute,
  OwnerSettingsIndexRoute: OwnerSettingsIndexRoute,
  OwnerEntityTypeChar91Char93ShapeRoute: OwnerEntityTypeChar91Char93ShapeRoute,
  OwnerEntityTypeChar91Char93ViewsViewKeyRoute:
    OwnerEntityTypeChar91Char93ViewsViewKeyRoute,
  OwnerDataChar91Char93ViewsViewKeyRoute:
    OwnerDataChar91Char93ViewsViewKeyRoute,
}

const OwnerRouteWithChildren = OwnerRoute._addFileChildren(OwnerRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OwnerRoute: OwnerRouteWithChildren,
  AccountSettingsRoute: AccountSettingsRoute,
  AuthAcceptInvitationRoute: AuthAcceptInvitationRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthLogoutRoute: AuthLogoutRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  OauthConsentRoute: OauthConsentRoute,
  OauthDeviceRoute: OauthDeviceRoute,
  OrgsNewRoute: OrgsNewRoute,
  SlackClaimRoute: SlackClaimRoute,
  ConnectorNameConnectionRoute: ConnectorNameConnectionRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
